import { useState, useRef, useEffect } from 'react';

import { formatNumberDisplay } from '../../../../utils/utils';

export const InputFromTo = ({
  formProps,
  defaultClasses,
  defaultValue = [],
  label,
  name,
  placeholder,
  type,
  isResetClicked,
  setIsResetClicked,
  setStatesInputsFromTo,
}) => {
  const [selectedValue, setSelectedValue] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [fromValue, setFromValue] = useState(
    defaultValue?.[0] || defaultValue?.[0] === 0 ? defaultValue[0] : ''
  );
  const [fromDisplayValue, setFromDisplayValue] = useState('');
  const [fromToValue, setFromToValue] = useState('');
  const [toValue, setToValue] = useState(
    defaultValue?.[1] || defaultValue?.[1] === 0 ? defaultValue[1] : ''
  );
  const [toDisplayValue, setToDisplayValue] = useState('');
  const [isLabelShown, setIsLabelShown] = useState();

  const dropdownRef = useRef(null);
  const Label = label;

  const fromName = `${name}_from`;
  const toName = `${name}_to`;

  const inputClasses =
    'flex flex-col gap-2 flex-1 w-full border border-gray-200 bg-white p-1 text-xs text-gray-900 focus:ring-0 focus:outline-none';

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
        handleSubmit();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [fromValue, toValue]);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleInputChange = e => {
    const { name, value } = e.target;
    const newValue = value.replace(/\D/g, '');

    if (name === fromName) {
      setFromValue(newValue);
      setFromDisplayValue(formatNumberDisplay(newValue));
    } else if (name === toName) {
      setToValue(newValue);
      setToDisplayValue(formatNumberDisplay(newValue));
    }
  };

  const handleSubmit = () => {
    const formatValue = val =>
      val ? `${formatNumberDisplay(val)}${type ? ` ${type}` : ''}` : '';

    const from = formatValue(fromValue);
    const to = formatValue(toValue);

    if (from && to) {
      setFromToValue(`${from} .. ${to}`);
    } else if (from) {
      setFromToValue(`From ${from}`);
    } else if (to) {
      setFromToValue(`To ${to}`);
    } else {
      setFromToValue('');
    }
  };

  useEffect(() => {
    setStatesInputsFromTo(prevState => [
      ...prevState,
      setFromToValue,
      setFromValue,
      setToValue,
    ]);
  }, [setFromToValue, setFromValue, setToValue, dropdownRef]);

  useEffect(() => {
    setSelectedValue(fromToValue);

    if (formProps?.setFieldValue) {
      const hasValue = fromValue || toValue;
      const newValue = hasValue ? [fromValue || '', toValue || ''] : [];
      formProps?.setFieldValue(name, newValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromToValue]);

  useEffect(() => {
    if (!selectedValue) {
      setIsLabelShown(false);
    } else {
      setIsLabelShown(true);
    }
  }, [selectedValue]);

  useEffect(() => {
    if (isResetClicked) {
      setIsLabelShown(false);
      setFromDisplayValue('');
      setToDisplayValue('');
      setIsResetClicked(false);
    }
  }, [isResetClicked]);

  useEffect(() => {
    if (defaultValue && defaultValue.length > 0) {
      handleSubmit();
      setFromDisplayValue(formatNumberDisplay(defaultValue[0]));
      setToDisplayValue(formatNumberDisplay(defaultValue[1]));
    }
  }, [defaultValue]);

  return (
    <>
      {label && (
        <Label
          name={name}
          placeholder={placeholder}
          isLabelShown={isLabelShown}
        />
      )}

      <input
        type="text"
        className={`${defaultClasses} pt-[0.3rem] pb-[0.42rem]`}
        value={fromToValue}
        placeholder={placeholder}
        name={name}
        readOnly
        onClick={toggleDropdown}
      />

      {showDropdown && (
        <div
          className="absolute flex flex-col gap-2 p-2 bg-gray-200 lg:flex-row z-[2]"
          ref={dropdownRef}
        >
          <label className="font-bold text-[16px]">
            {type ? `From, ${type}` : 'From'}
            <input
              name={fromName}
              type="text"
              value={fromDisplayValue}
              onChange={handleInputChange}
              className={inputClasses}
            />
          </label>

          <label className="font-bold text-[16px]">
            {type ? `To, ${type}` : 'To'}
            <input
              name={toName}
              type="text"
              value={toDisplayValue}
              onChange={handleInputChange}
              className={inputClasses}
            />
          </label>
        </div>
      )}
    </>
  );
};
